import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { Location } from "@/components/site/Location";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, anchors: true }}>
      <div className="App">
        <div className="noise-overlay" />
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <About />
          <Gallery />
          <Location />
          <Reviews />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
